import { render } from "./EditSubscriber.vue?vue&type=template&id=36993096&scoped=true"
import script from "./EditSubscriber.vue?vue&type=script&lang=js"
export * from "./EditSubscriber.vue?vue&type=script&lang=js"

import "./EditSubscriber.vue?vue&type=style&index=0&id=36993096&scoped=true&lang=css"

import exportComponent from "/opt/karibu-hrms/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36993096"]])

export default __exports__